import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router';
import Routes from './routes';
import Vuex from "vuex";
import Viewscore from './components/Viewscore.vue'
import Login from './components/Login';
import Dasboard from './components/Dasboard';
import Account  from './components/Account.vue'
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex);

const store = new Vuex.Store(
    {
        state: {
            authenticated: localStorage.getItem('hasLogin')
        },
        mutations: {
            setAuthentication(state, status) {
                state.authenticated = status;
            }
        }
    }
);


const router = new VueRouter({
    routes: [
        {
            path:'/account-info',
            name:'accountstudent',
            component:Account
       },
        {
            path:'',
            redirect:{
                name:'login'
            }
        },
        {
            path:'/view/score',
            name:'view-score',
            component:Viewscore,
            beforeEnter: (to, from, next) => {
                console.log(store.state.authenticated)
                if(store.state.authenticated == false || store.state.authenticated == null) {

               
                        next({ name: 'login'})

                } else {
                    
                               
                        
                        next()

                  
                  
                }
                
            }
            
            
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            
        },
        {
            path: "/score/dashboard",
            name: "dashboard",
            component: Dasboard,
            beforeEnter: (to, from, next) => {
                console.log(store.state.authenticated)
                if(store.state.authenticated == false || store.state.authenticated == null) {

               
                        next({ name: 'login'})

                } else {
                    
                               
                        
                        next()

                  
                  
                }
                
            }
        }
    ],
    mode: 'hash',
});


new Vue({
    render: h => h(App),
    vuetify,
    router: router,
    store: store,
  
}).$mount('#app')